// @ts-nocheck

import React from 'react';
import styled from 'styled-components';

import MatchHotBetGroupOutcomeContainer from '../MatchHotBetGroupOutcome/MatchHotBetGroupOutcomeContainer';

import { type HotBetGroupOutcomeData } from './MatchHotBetGroups.selector';

const Wrapper = styled.div`
  position: relative;
  padding: 0.6em;
`;

type MatchHotBetGroupsProps = {
  className?: string;
  outcomesData: Array<HotBetGroupOutcomeData>;
};

const MatchHotBetGroups = ({ className = '', outcomesData }: MatchHotBetGroupsProps) => {
  return (
    <Wrapper className={className}>
      {outcomesData.map((outcomeData) => (
        <MatchHotBetGroupOutcomeContainer
          {...outcomeData}
          key={`${outcomeData.outcomeId}${outcomeData.isMultichoice ? '-multichoice' : ''}`}
        />
      ))}
    </Wrapper>
  );
};

export default MatchHotBetGroups;
